import {DG_axios} from "../../../custom/axios";

const urlCustomers = `/dogoo/customer-rest/v2.0/customers/`

export async function getCustomerId(id) {
    const response = await DG_axios.get(`${urlCustomers}/${id}`)
    return response?.data || []
}

const apiUrl = "/dogoo/service-product-rest/v2.0/service-product"

export async function getAllProducts({search, filter, page = 1, pageSize = 50, sort}) {
    const params = {
        search, filter, page, pageSize, sort
    }
    const response = await DG_axios.get(apiUrl, {params})
    return response?.data || []

}